<div class="temperature-container"></div>
